// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__2HUqp","loader":"ContentLoader_loader__1xbim","disabled":"ContentLoader_disabled__1St6_"};